const genericFooterItem = { sc_o: 'navigation_footer' };

const _companyLinks = {
  newWorkFooter: genericFooterItem,
  careersFooter: genericFooterItem,
  investorRelationsFooter: genericFooterItem,
  pressFooter: genericFooterItem,
  newWorkExperienceFooter: genericFooterItem,
};

const _legalLinks = {
  imprintFooter: genericFooterItem,
  tAndCFooter: genericFooterItem,
  privacyAtXingFooter: genericFooterItem,
  privacyPolicyFooter: genericFooterItem,
};

const _mainSectionsLinks = {
  peopleDirectoryFooter: genericFooterItem,
  jobsFooter: genericFooterItem,
  eventsFooter: genericFooterItem,
  newsFooter: genericFooterItem,
  groupsFooter: genericFooterItem,
  companiesFooter: genericFooterItem,
  coachesFooter: genericFooterItem,
};

const _membershipsLinks = {
  premiumOfferFooter: genericFooterItem,
  proJobsOfferFooter: genericFooterItem,
  proBusinessOfferFooter: genericFooterItem,
};

const _resourcesLinks = {
  helpFooter: genericFooterItem,
  xingCommunityFooter: genericFooterItem,
  blogFooter: genericFooterItem,
  devBlogFooter: genericFooterItem,
  appsFooter: genericFooterItem,
};

const _servicesLinks = {
  eRecruitingOfferFooter: genericFooterItem,
  halloFreelancerOfferFooter: genericFooterItem,
  advertisementOfferFooter: genericFooterItem,
  marketingSolutionsOfferFooter: genericFooterItem,
  xingEventsOfferFooter: genericFooterItem,
  curriculumVitaeEditorFooter: genericFooterItem,
  coverLetterEditorFooter: genericFooterItem,
  jobApplicationTipsFooter: genericFooterItem,
  kununuOfferFooter: genericFooterItem,
};

const _languageLinks = {
  languageSwitchFooter: genericFooterItem,
};

const footerTrackings = {
  ..._companyLinks,
  ..._legalLinks,
  ..._mainSectionsLinks,
  ..._membershipsLinks,
  ..._resourcesLinks,
  ..._servicesLinks,
  ..._languageLinks,
};

export { footerTrackings };
